export default __webpack_public_path__ + "static/media/starimg_wrong.3dab77a4.svg";